import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LiveCoaching from './LiveCoaching';
import AutoCoachingSession from './AutoCoachingSession';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Mode selector for /live-coaching.
 *
 * Reads the user's `auto_mode_enabled` preference once on mount and
 * routes to either AutoCoachingSession (default, hands-free via
 * ElevenLabs Agents) or the classic LiveCoaching (press-and-hold).
 *
 * Keeps the two components fully isolated so a bug in Auto mode can't
 * regress Hold-to-Talk users, and vice versa.
 */
const LiveCoachingRouter = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null); // null = still loading

  useEffect(() => {
    const token = localStorage.getItem('sage_token');
    if (!token) {
      navigate('/login');
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        // Default to Auto if the field is missing (older users pre-migration).
        setMode(data.auto_mode_enabled === false ? 'hold' : 'auto');
      })
      .catch(() => {
        // On auth failure, fall back to Hold-to-Talk which has its own
        // auth check; don't block the user on this preference lookup.
        setMode('hold');
      });
  }, [navigate]);

  if (mode === null) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-white/50 text-sm">Loading SAGE…</div>
      </div>
    );
  }

  if (mode === 'auto') {
    return <AutoCoachingSession onExit={() => navigate('/dashboard')} />;
  }

  return <LiveCoaching />;
};

export default LiveCoachingRouter;
